import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-help-popup',
  templateUrl: './help-popup.component.html',
  styleUrls: ['./help-popup.component.scss']
})
export class HelpPopupComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  closeicon=this.RESOURCE_SERVER_URL+'/assets/images/Case_Review_Icons/Close.svg'
  @Input() label;
  @Output() closeHelpIcon = new EventEmitter();
  helplabel:any
  constructor(private commonService: CommonService,) {
    this.commonService.languagechnage.subscribe(data=>{
      if (data){
        this.helplabel=this.commonService.language;
        this.commonService.updatehelpjson(false)
      }
    })
   }

  ngOnInit(): void {
    this.helplabel=this.commonService.language
  }
  onClose() {
    this.closeHelpIcon.emit()
  }
}
